import React from 'react';

const TextAreaField = ({ label, placeholder, name, id, rows = 5, required = true, value, onChange }) => {
  return (
    <div className="w-full mb-4">
      <label 
        htmlFor={id || name} 
        className="block font-body text-base mb-2  "
      >
        {label}{required && "*"}
      </label>
      <textarea
        id={id || name}
        name={name}
        rows={rows}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className="w-full bg-white text-black font-body px-4 py-3 rounded-md 
                   border border-border-color focus:outline-none focus:ring-2 
                    focus:ring-background-dark transition-all duration-200 
                     placeholder:text-txt-sec text-base shadow-sm "
      />
    </div>
  );
};

export default TextAreaField;